import { h } from '..//index.js';
export const selectProcedures = (state) => {
    const procedures = state.procedures;
    if (!h.isLoaded(procedures)) {
        return null;
    }
    return procedures.data;
};
export const selectCaseProcedures = (state, caseCreditorId, tenantId, caseCollectorId) => {
    const procedures = selectProcedures(state);
    return procedures
        ? procedures.filter((procedure) => {
            const isCreditorSame = !procedure.creditorId || procedure.creditorId === caseCreditorId;
            const isCollectorSame = !procedure.collectorId || procedure.collectorId === caseCollectorId;
            return isCreditorSame && isCollectorSame && procedure.showOnCase;
        })
        : [];
};
//# sourceMappingURL=selectors.js.map